import { unstable_rethrow } from 'next/navigation'

/** Keeps a local catch or error boundary from swallowing redirect/notFound. */
export function rethrowControlFlow(error: unknown): void {
  unstable_rethrow(error)
}

/** True when `error` is Next.js control flow rather than an application failure. */
export function isControlFlowError(error: unknown): boolean {
  try {
    unstable_rethrow(error)
    return false
  } catch {
    return true
  }
}
